import {token} from 'brandi';

import {DailyRewardsService} from '@/services/DailyRewardsService/DailyRewardsService';
import type {DevPanel} from '@/services/DevPanel/DevPanel';
import {DevPanelService} from '@/services/DevPanelService/DevPanelService';
import {IProjectApi} from '@/services/ProjectApi/types';
import {TooltipsService} from '@/services/TooltipsService/TooltipsService';
import {WindowVisibilityService} from '@/services/WindowVisibilityService/WindowVisibilityService';
import {GameOperationsService} from '@/services/shared/GameOperationsService/GameOperationsService';
import {GameStatisticsDevPanel} from '@/services/shared/GameStatisticsService/GameStatisticsDevPanel';
import {GameStatisticsService} from '@/services/shared/GameStatisticsService/GameStatisticsService';
import {GameStatusService} from '@/services/shared/GameStatusService/GameStatusService';
import {GiftsDevPanel} from '@/services/shared/GiftsService/GiftsDevPanel';
import {GiftsService} from '@/services/shared/GiftsService/GiftsService';
import {ImprovementsService} from '@/services/shared/ImprovementsService/ImprovementsService';
import {LeaderBoardDevPanel} from '@/services/shared/LeaderBoardService/LeaderBoardDevPanel';
import {LeaderBoardService} from '@/services/shared/LeaderBoardService/LeaderBoardService';
import {OnboardingService} from '@/services/shared/OnboardingService/OnboardingService';
import {SettingsService} from '@/services/shared/SettingsService/SettingsService';
import {ShareService} from '@/services/shared/ShareService/ShareService';
import {WinnersService} from '@/services/shared/WinnersService/WinnersService';
import {ClickerStateStore} from '@/stores/ClickerStateStore/ClickerStateStore';
import {DailyGameStore} from '@/stores/DailyGameStore/DailyGameStore';
import {DailyRewardsStore} from '@/stores/DailyRewardsStore/DailyRewardsStore';
import {GameStatisticsStore} from '@/stores/GameStatisticsStore/GameStatisticsStore';
import {GameStatusStore} from '@/stores/GameStatusStore/GameStatusStore';
import {GiftsStore} from '@/stores/GiftsStore/GiftsStore';
import {ImprovementsStore} from '@/stores/ImprovementsStore/ImprovementsStore';
import {LeaderBoardStore} from '@/stores/LeaderBoardStore/LeaderBoardStore';
import {NavigationClickerModalStore} from '@/stores/NavigationClickerModalStore/NavigationClickerModalStore';
import {OnboardingStore} from '@/stores/OnboardingStore/OnboardingStore';
import {SettingsStore} from '@/stores/SettingsStore/SettingsStore';
import {ShareStore} from '@/stores/ShareStore/ShareStore';
import {TasksStore} from '@/stores/TasksStore/TasksStore';
import {TooltipsStore} from '@/stores/TooltipsStore/TooltipsStore';
import {UserStore} from '@/stores/UserStore/UserStore';
import {WinnersStore} from '@/stores/WinnersStore/WinnersStore';
import {MainPageAnimation} from '@/ui/components/MainPageAnimation/MainPageAnimation';
import {ConfettiAnimation} from '@/ui/kit/ConfettiAnimation/ConfettiAnimation';

export const DOMAIN_TOKENS = {
  projectApi: token<IProjectApi>('projectApi'),
  userStore: token<UserStore>('userStore'),
  tasksStore: token<TasksStore>('tasksStore'),
  leaderBoardStore: token<LeaderBoardStore>('leaderBoardStore'),
  leaderBoardService: token<LeaderBoardService>('leaderBoardService'),
  leaderBoardDevPanel: token<LeaderBoardDevPanel>('leaderBoardDevPanel'),
  dailyGameStore: token<DailyGameStore>('dailyGameStore'),
  clickerStateStore: token<ClickerStateStore>('clickerStateStore'),
  gameOperationsService: token<GameOperationsService>('clickerStateService'),
  gameStatusStore: token<GameStatusStore>('gameStatusStore'),
  gameStatusService: token<GameStatusService>('gameStatusService'),
  improvementsStore: token<ImprovementsStore>('improvementsStore'),
  improvementsService: token<ImprovementsService>('improvementsService'),
  navigationClickerModalStore: token<NavigationClickerModalStore>('navigationClickerModalStore'),
  dailyRewardsStore: token<DailyRewardsStore>('dailyRewardsStore'),
  dailyRewardsService: token<DailyRewardsService>('dailyRewardsService'),
  shareService: token<ShareService>('shareService'),
  shareStore: token<ShareStore>('shareStore'),
  giftsStore: token<GiftsStore>('giftsStore'),
  onboardingStore: token<OnboardingStore>('onboardingStore'),
  onboardingService: token<OnboardingService>('onboardingService'),
  giftsService: token<GiftsService>('giftsService'),
  giftsDevPanel: token<GiftsDevPanel>('giftsDevPanel'),
  settingsService: token<SettingsService>('settingsService'),
  settingsStore: token<SettingsStore>('settingsStore'),
  windowVisibilityService: token<WindowVisibilityService>('windowVisibilityService'),
  devPanel: token<DevPanel>('devPanel'),
  devPanelService: token<DevPanelService>('devPanelService'),
  mainPageAnimation: token<MainPageAnimation>('mainPageAnimation'),
  tooltipsStore: token<TooltipsStore>('tooltipsStore'),
  tooltipsService: token<TooltipsService>('tooltipsService'),
  gameStatisticsStore: token<GameStatisticsStore>('gameStatisticsStore'),
  gameStatisticsService: token<GameStatisticsService>('gameStatisticsService'),
  gameStatisticsDevPanel: token<GameStatisticsDevPanel>('gameStatisticsDevPanel'),
  confettiAnimation: token<ConfettiAnimation>('confettiAnimation'),
  winnersService: token<WinnersService>('winnersService'),
  winnersStore: token<WinnersStore>('winnersStore'),
};
